import React from "react";

import { useTranslation } from "react-i18next";

import { FormFileInput } from "@/uiKit/molecules/form/FormFileInput.tsx";

type PatientInfo = {
  givenName: string;
  familyName: string;
};

export type TreatmentPrescriptionFormFieldProps = {
  patientInfo: PatientInfo;
  name?: string;
  className?: string;
};

export const TreatmentPrescriptionFormField: React.FC<TreatmentPrescriptionFormFieldProps> = ({
  patientInfo,
  name = "treatmentPrescriptionAttachment",
  className,
}) => {
  const { t } = useTranslation();

  return (
    <FormFileInput
      id="treatment-prescription-form-field"
      name={name}
      label={t("diabetesForms.treatmentPrescription")}
      uploadLabel={t("diabetesForms.uploadTreatmentPrescription")}
      fileType="treatment"
      reserveErrorSpace
      patientInfo={patientInfo}
      className={className}
    />
  );
};
